import { Tag } from 'antd';
import styled from 'styled-components/macro';

export const RoundedTag = styled(Tag)`
  border-radius: 16px;
  gap: 10px;
  width: fit-content;
`;

// Title, status tag and actions stay in normal flow and wrap instead of overlapping.
export const SsoCardHeader = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 8px 16px;
`;

export const SsoTagContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const CopyTagButton = styled.button`
  display: block;
  max-width: 100%;
  padding: 0;
  border: none;
  border-radius: 16px;
  background: none;
  font: inherit;
  text-align: left;
  cursor: pointer;
  &:focus-visible {
    outline: 2px solid #a793f6;
    outline-offset: 2px;
  }
`;

// Groups a copy tag's text into one flex item. `&&` outranks the container's `span`
// rule below, so the text keeps the tag's own color and size.
export const CopyTagText = styled.span`
  && {
    color: inherit;
    font-size: inherit;
    line-height: inherit;
  }
`;

export const SsoInformationContainer = styled.div`
  display: grid;
  span {
    font-size: 14px;
    line-height: 20px;
    color: #57575c;
  }
  .sso-tag {
    display: flex;
    font-size: 12px !important;
    line-height: 14px;
    font-weight: 450;
    color: white;
    padding: 7px 12px;
  }
  .attributes-section {
    margin-top: 50px;
    font-weight: 700;
    border-left: 3px solid #ff5e5e;
    color: #57575c;
  }
  .attributes-list {
    margin-left: 10px;
  }
  .documentation-section {
    margin-top: 50px;
    a {
      color: #111a27;
      text-decoration: underline;
    }
  }
  .w-500 {
    font-weight: 500;
  }
`;
